import { PlayfulThemeId } from '../identifiers';
import { PlayfulThemeDefinition } from '../types';
import { IconName } from '@/icons/types';
import { CandyMascot } from '@/components/core/ThemeMascot/mascots';

export const candyTheme: PlayfulThemeDefinition = {
  id: PlayfulThemeId.CANDY,
  hover: {
    transform: 'scale(1.06) rotate(-1deg)',
    transition: 'transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)',
  },
  click: {
    transform: 'scale(0.88)',
    transition: 'transform 0.1s ease-out',
  },
  idle: {
    animationName: 'playful-candy-squish',
    animationDuration: '2s',
    animationTimingFunction: 'ease-in-out',
    animationIterationCount: 'infinite',
  },
  dragStart: {
    transform: 'scale(1.1) rotate(2deg)',
    transition: 'transform 0.15s ease-out',
  },
  particles: {
    enabled: true,
    count: 10,
    characters: ['🍬', '🍭', '🎀', '💖'],
    spread: 65,
    duration: 1000,
    size: 16,
  },
  keyframes: [
    {
      name: 'playful-candy-squish',
      css: `@keyframes playful-candy-squish {
  0%, 100% { transform: scale(1) rotate(0deg); }
  30% { transform: scale(1.02) rotate(0.5deg); }
  60% { transform: scale(0.98) rotate(-0.5deg); }
}`,
    },
  ],
  sounds: {
    hover: { name: 'ui/button_squishy', volume: 0.15 },
    click: { name: 'ui/pop_open', volume: 0.3 },
  },
  metadata: {
    label: 'Candy',
    icon: IconName.HEART,
    previewEmoji: '🍬',
    description: 'Sweet squishy pops',
    mascotEmoji: '🍭',
    mascotComponent: CandyMascot,
  },
};
